export enum Permission {
  VIEW_USERS = '01',
  EDIT_USER = '02',
  DELETE_USER = '03',
  CREATE_USER = '04',
  VIEW_USER_GROUPS = '05',
  CREATE_USER_GROUP = '06',
  EDIT_USER_GROUP = '07',
  DELETE_USER_GROUP = '08',
  VIEW_SITES = '09',
  CREATE_SITES = '0a',
  EDIT_SITES = '0b',
  DELETE_SITES = '0c',

  EXPENSE_CREATE = '0d',
  EXPENSE_REVIEW = '0e',
  EXPENSE_APPROVE = '0f',

  INCOME_CREATE = '0g',
  INCOME_REVIEW = '0h',
  INCOME_APPROVE = '0i',

  PETTYCASH_ACCOUNT_CREATE = '0j',
  PETTYCASH_REPLENISH = '0k',
  PETTYCASH_CREATE = '0l',
  PETTYCASH_REVIEW = '0m',
  PETTYCASH_APPROVE = '0n',

  COA_VIEW = '0o',
  COA_EDIT = '0p',

  TRANSACTION_CREATE = '0q',
  TRANSACTION_UPDATE = '0r',
  TRANSACTION_DELETE = '0s',

  GL_VIEW = '0t',

  EXPENSE_VIEW = '0u',
  INCOME_VIEW = '0v',
  PETTYCASH_VIEW = '0w',
}
